import { BaseLRUStore } from 'generic/baseLRUStore';
import { Dispatch } from '@reduxjs/toolkit';
import { removeWellDropImage } from 'redux/reducers/wellReducer';
import { ImageTuningValues } from 'business/models/ImageTuningModel';

type WellDropImageStoreItem = {
  original?: HTMLImageElement;
  tuned?: HTMLImageElement;
  tuningValues?: ImageTuningValues;
};
const maxCacheSize = 200; // Maximum number of images to cache

class WellDropImageStore extends BaseLRUStore<string, WellDropImageStoreItem> {
  private static _instance: WellDropImageStore;
  private dispatch?: Dispatch;
  private constructor() {
    super(maxCacheSize);
  }

  public static getInstance(): WellDropImageStore {
    if (!WellDropImageStore._instance) {
      WellDropImageStore._instance = new WellDropImageStore();
    }
    return WellDropImageStore._instance;
  }

  public injectDispatch(dispatch: Dispatch) {
    if (!this.dispatch) {
      this.dispatch = dispatch;
    }
  }

  protected override onEvict(key: string, value: WellDropImageStoreItem) {
    if (!this.dispatch) {
      console.warn('Dispatch function is not set. Cannot remove image from store.');
      return;
    }

    this.dispatch(removeWellDropImage({ key }));
  }

  public replaceTunedImage(
    key: string,
    tunedImage: HTMLImageElement,
    tuningValues: ImageTuningValues,
  ) {
    const item = this.get(key);
    if (item) {
      item.tuned = tunedImage;
      item.tuningValues = tuningValues;
      this.set(key, item);
    } else {
      console.warn(`No item found for key: ${key}`);
    }
  }
}

export default WellDropImageStore.getInstance() as WellDropImageStore;
